@if (isRouteLoading()) {
  <div class="route-loader-overlay" aria-live="polite" aria-label="Loading page">
    <img src="assets/hytec-logo.png" alt="Hytec Power Inc" class="route-loader-logo" />
  </div>
}

<router-outlet />
<back-to-top />
